import { useEffect, useRef } from 'react';
import { get, isString, noop } from 'lodash/fp';

const DEFAULT_OPTIONS = {
    callback: noop,
    stopPropagation: true,
    preventDefault: true,
    ignore: false
};

export function useEventListener(targetElement, eventName, optionsProp = {}) {
    const options = { ...DEFAULT_OPTIONS, ...optionsProp };
    const { callback, stopPropagation, preventDefault, ignore } = options;
    const savedHandler = useRef();

    useEffect(() => {
        savedHandler.current = callback;
    }, [callback]);

    useEffect(() => {
        if (ignore) {
            return;
        }

        let element = get('current', targetElement);

        if (targetElement instanceof HTMLElement) {
            element = targetElement;
        }

        if (isString(targetElement)) {
            element = document.querySelector(targetElement);
        }

        if (element) {
            const eventListener = (event) => {
                if (stopPropagation) {
                    event.stopImmediatePropagation();
                    event.stopPropagation();
                }

                if (preventDefault) {
                    event.preventDefault();
                }

                return savedHandler.current(event);
            };

            element.addEventListener(eventName, eventListener);

            return () => {
                element.removeEventListener(eventName, eventListener);
            };
        }
    }, [eventName, targetElement, ignore, stopPropagation, preventDefault]);
}
